import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';

import { OrganizationService } from '../services';

export const singleOrganizationRedirectGuard: CanMatchFn = () => {
  const organizations = inject(OrganizationService);
  const router = inject(Router);
  if (organizations.hasMultiple) return true;
  const soleId = organizations.primaryId() ?? organizations.organizations[0]?.id;
  return soleId ? router.parseUrl(`/organizations/${soleId}`) : true;
};
